<template>
  <div>
    <section class="donate-card__info_section">
      <h3 class="mb-4">Donation amount: ${{ amount }}</h3>
      <h4>Your Information</h4>
      <DonateCardStepTwoSelectTitle :form="form.title" v-model="form.title"/>
        <span class="w-full text-sm text-red"
        v-if="showValidationErrors && !$v.form.personal_info.title.required">
            Title is required
        </span>

        <div class="w-full lg:w-1/2">
            <input
                    v-model="form.first_name"
                    class="donate-card__input_half donate-card__input_half_l w-full mr-0 lg:mr-1"
                    name="first_name"
                    placeholder="First Name *"
            >
            <div class="w-full text-sm text-red"
            >
                <span  v-show="showValidationErrors && !$v.form.personal_info.first_name.required"> First name is required</span>
            </div>
        </div>

        <div class="w-full lg:w-1/2">
            <input
                    v-model="form.last_name"
                    class="donate-card__input_half donate-card__input_half_r ml:0 lg:ml-1 w-full"
                    name="last_name"
                    placeholder="Last Name *"
            >


            <div class="ml:0 lg:ml-1 text-sm text-red">
                <span  v-show="showValidationErrors && !$v.form.personal_info.last_name.required"> Last name is required</span>
            </div>
        </div>


      <input
        v-model="form.email"
        class="donate-card__input_full"
        name="email_address"
        placeholder="Email *"
      >
        <span class="w-full text-sm text-red"
              v-if="showValidationErrors && !$v.form.personal_info.email.required">
            Email is required
        </span>
        <span class="w-full text-sm text-red"
              v-if="showValidationErrors && !$v.form.personal_info.email.email">
            Email is invalid
        </span>

         <input
        v-model="form.phone"
        class="donate-card__input_full"
        name="phone"
        placeholder="Phone number"
      >
    </section>

    <section class="donate-card__info_section">
      <h4>Billing Address</h4>
      <input
        v-model="form.address"
        class="donate-card__input_full"
        name="address_line1"
        placeholder="Street Address *"
      >
        <span class="w-full text-sm text-red"
              v-if="showValidationErrors && !$v.form.personal_info.address.required">
            Address is required
        </span>

        <div class="w-full lg:w-1/2">
            <input
                    v-model="form.city"
                    class="donate-card__input_half donate-card__input_half_l w-full mr-0 lg:mr-1"
                    name="city"
                    placeholder="City *"
            >
            <div class="text-sm text-red"
            >
                <span  v-show="showValidationErrors && !$v.form.personal_info.city.required"> City is required</span>
            </div>
        </div>

        <div class="w-full lg:w-1/2">
            <DonateCardStepTwoSelectState class="w-full ml-0 lg:ml-1"  v-model="form.state" />

            <div class="ml:0 lg:ml-1 text-sm text-red">
                <span  v-show="showValidationErrors && !$v.form.personal_info.state.required">State is required</span>
            </div>
        </div>


        <div class="w-full lg:w-1/2">
            <input
                    v-model="form.zip_code"
                    class="donate-card__input_half donate-card__input_half_r w-full mr-0 lg:mr-1"
                    name="zip_code"
                    placeholder="Zip Code *"
            >

            <div class="text-sm text-red">
                <span  v-show="showValidationErrors && !$v.form.personal_info.zip_code.required">Zip Code is required</span>
            </div>
        </div>
        <div class="w-full lg:w-1/2">
            <DonateCardStepTwoSelectCountry
                    :countries="countries"
                    v-model="form.country"
                    class="w-full ml-0 lg:ml-1"
                    name="country" />

            <div class="ml-0 lg:ml-1 text-sm text-red">
                <span  v-show="showValidationErrors && !$v.form.personal_info.country.required">Country is required</span>
            </div>
        </div>

    </section>

      <section class="donate-card__info_section">
      <h4>Payment Information</h4>
      <card
        :options="stripeOptions"
        :stripe="token"
        class="donate-card__input_full"
        @change="handleCardChange"
      />
    </section>

    <section class="donate-card__gdpr_communication_section">
       <div class="donate-card__gdpr_text"
       v-if="contents.is_gdpr_visible === '1'"
       v-html="contents.gdpr_text"
      >

      </div>

        <div class="donate-card__communication_checkbox_text"
        v-if="contents.is_communication_checkbox_visible === '1'"
      >
      <input v-model="form.communication_consent" type="checkbox" id="communication_checkbox" name="communication_checkbox">
      <label for="communication_checkbox">
         {{ contents.communication_checkbox_text }}
      </label>
     
      </div>
    </section>
  </div>
</template>
<script>
import DonateCardStepTwoSelectTitle from './DonateCardStepTwoSelectTitle'
import DonateCardStepTwoSelectState from './DonateCardStepTwoSelectState'
import DonateCardStepTwoSelectCountry from './DonateCardStepTwoSelectCountry'
import DonateCardStepTwoSelectMonth from './DonateCardStepTwoSelectMonth'
import DonateCardStepTwoSelectYear from './DonateCardStepTwoSelectYear'
import { Card } from 'vue-stripe-elements-plus'

export default {
  name: 'DonateCardStepTwo',

  components: {
    Card,
    DonateCardStepTwoSelectTitle,
    DonateCardStepTwoSelectState,
    DonateCardStepTwoSelectCountry,
    DonateCardStepTwoSelectMonth,
    DonateCardStepTwoSelectYear
  },

  props: {
    $v: {
      type: Object
    },
    contents: {
      type: Object,
      default: () => ({})
    },
    showValidationErrors: {
      type: Boolean,
      default: false
    },
    amount: {
      type: String,
      required: true
    },

    countries: {
      type: [Array, Object],
      required: true
    },

    token: {
      type: String,
      required: true
    },

    form: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      stripeOptions: {
        hidePostalCode: true
      }
    }
  },

  watch: {
    form: {
      deep: true,
      handler(value) {
        this.$emit('input', this.form)
      }
    }
  },

  methods: {
    handleCardChange(event) {
      this.$emit('update:validCard', event.complete && !event.error)
    }
  }
}
</script>
